<app-problem-multiple-choice-container
  (onNext)="handleNext()"
  [isPersistences]="false"
  [nextProblemButton]="'Complete exercise'">
</app-problem-multiple-choice-container>
